import { render, staticRenderFns } from "./VerticalNavMenuDropNft.vue?vue&type=template&id=6254c476&"
import script from "./VerticalNavMenuDropNft.vue?vue&type=script&lang=js&"
export * from "./VerticalNavMenuDropNft.vue?vue&type=script&lang=js&"
import style0 from "./VerticalNavMenuDropNft.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports